export default {
    l_User_name: "User name",
    l_Phone: "Phone",
    l_User_password: "User password",
    l_Forgot_password: "Forgot password",
    l_Login: "Log in",
    l_Sign_out: "Sign out",
    l_EmailorPasswordisWrong: "Email or passwordis wrong",
    l_User: "User",
    l_Payments: "Payments",
    l_Promocodes: "Promocodes",
    l_Messages: "Messages",
    l_Consolidations: "Consolidations",
    l_Courier_Orders: "Courier Orders",
    l_Almaty: "Almaty",
    l_Temu_return_back: "Temu return back",
    l_Name: "Name",
    l_Add: "Add",
    l_On_shelf: "On shelf",
    l_Action: "Action",
    l_Return_excel: "Return M-Batch Excel",
    l_Update: "Update",
    l_Remark_time: "Remark time",
    l_Remark_JPID: "Remark JPID",
    l_Accepted_JPID: "Accepted JPID",
    l_Accepted_stationCode: "Accepted Stationcode",
    l_Remark_stationCode: "Remark Stationcode",
    l_Edit: "Edit",
    l_Submit: "Submit",
    l_Total_weight: "Total weight",
    l_Medium_batch_count: "Medium batch count",
    l_Cancel: "Cancel",
    l_Last_trackcodes: "Last trackes",
    l_Are_you_sure_delete_this_task: "Are you sure delete this task?",
    l_Yes: "Yes",
    l_No: "No",
    l_Tracking_number: "Tracking number",
    l_Internal_Tracking_number: "Internal Tracking number",
    l_Actual_Price: "Actual Price",
    l_Estimated_price: "Estimated price",
    l_Actual_weight: "Actual weight",
    l_kg: "kg",
    l_Estimated_weight: "Estimated weight",
    l_Delivery_country: "Delivery country",
    l_Delivery_type: "Delivery type",
    l_Address: "Address",
    l_Execution_status: "Execution reason-status",
    l_Cargo: "Cargo",
    l_Sign_up: "Sign up",
    l_Next: "Next",
    l_Verify_code: "Verify code",
    l_Set_password: "Set password",
    l_Confirm_password: "Confirm password",
    l_Get_SMS: "Get SMS",
    l_Get_the_verification_code_first: "Get the verification code first",
    l_Confirm_password_error: "Confirm password error",
    l_Phone_number: "Phone number",
    l_Password: "Password",
    l_Wrong_password_format: "Wrong password format",
    l_Please_enter_phone_number: "Please enter phone number",
    l_Please_enter_sms: "Please enter SMS",
    l_My_addresses: "My addresses",
    l_My_parcels: "My parcels",
    l_Buy_instead_of_me: "Buy instead of me",
    l_Personal_data: "Personal data",
    l_Update_password: "Update password",
    l_Old_Password: "Old password",
    l_New_Password: "New password",
    l_Successed: "Successed",
    l_Personal_information: "Personal information",
    l_User_list: "User list",
    l_Email: "Email",
    l_Add_user: "Add user",
    l_Full_name: "Full name",
    l_IIN: "IIN",
    l_ID_number: "ID number",
    l_Issuing_authority: "Issuing authority",
    l_Issue_date: "Issue date",
    l_Validity: "Validity",
    l_Delivery_address: "Delivery address",
    l_Town: "City/Town",
    l_Street: "Street",
    l_House: "House",
    l_Postcode: "Postcode",
    l_Identity_card: "Identity card",
    l_Facial: "Facial",
    l_Negotiable: "Negotiable",
    l_Draw_a_signature: "Draw a signature",
    l_Or_download_the_signed_contract: "Or download the signed contract",
    l_Note: "Note",
    l_Precautions_for_uploading_pictures: "The attached document must be of good quality. The image file must not exceed 1 MB.",
    l_Click_or_drag_ile_to_this_area_to_upload: "Click or drag file to this area to upload",
    l_My_order: "My order",
    l_Track_code: "Track code",
    l_Recipient: "Recipient",
    l_Cargo_name: "Cargo name",
    l_Declared_price: "Declared price",
    l_Date: "Date",
    l_Delivery_cost: "Delivery cost",
    l_Dispatch_country: "Dispatch country",
    l_Delivery_method: "Delivery method",
    l_Order: "Order",
    l_Recipient_data: "Recipient data",
    l_Shipping_country: "Shipping country",
    l_Transportation_method: "Transportation method",
    l_Price: "Price",
    l_Quantity: "Quantity",
    l_Total_cost: "Total cost",
    l_Category: "Category",
    l_Weapons_and_explosive_materials: "Weapons and explosive materials",
    l_Alcoholic_drinks: "Alcoholic drinks",
    l_Sprays_and_aerosols: "Sprays and aerosols",
    l_Medicines_without_a_doctors_prescription: "Medicines without a doctor's prescription",
    l_radioactive_elements: "radioactive elements",
    l_Animals_and_plants: "Animals and plants",
    l_ALL_RIGHTS_RESERVED: "ALL RIGHTS RESERVED",
    l_Contact: "Contact",
    l_About_us: "About us",
    l_The_shops: "The shops",
    l_How_it_works: "How it works?",
    l_Rates: "Rates",
    l_Frequently_asked_Questions: "Frequently asked Questions",
    l_Prohibited_Items: "Prohibited Items",
    l_Privacy_Policy: "Privacy Policy",
    l_Weight: "Weight",
    l_Declaration: "Declaration",
    l_Pay: "Pay",
    l_Provinces: "Provinces",
    l_Country: "Country",
    l_Full_address: "Full address",
    l_MY_ADDRESS_IN_CHINA_FOR_AUTO_DELIVERY: "MY ADDRESS IN CHINA FOR AUTO DELIVERY",
    l_Add_product: "Add cargo",
    l_Please_enter_quantity: "Please enter quantity",
    l_The_maximum_number_is: "The maximum number is",
    l_China: "China",
    l_Auto_delivery: "Auto delivery",
    l_To_avoid_problems_during_customs_clearance_please_enter_a_detailed_description_of_the_product_name_in_Russian: "To avoid problems during customs clearance, please enter a detailed description of the product name in Russian.",
    l_Later_confirm: "Later Confirm",
    l_Confirm: "Confirm",
    l_Succeed: "Succeed",
    l_Provide_a_link_to_the_product_we_will_buy_and_bring_it_for_you: "Provide a link to the product, we will buy and bring it for you!",
    l_Cargo_link: "Cargo link",
    l_Additional_comment: "Additional comment",
    l_Are_you_willing_to_buy_if_the_price_fluctuates_up_to_7: "Are you willing to buy if the price fluctuates up to 7% ?",
    l_size: "Size",
    l_Color: "Color",
    l_Delivery_price: "Delivery price",
    l_Promo_codes: "Promo codes",
    l_Whether_the_payment_is_completed: "Whether the payment is completed?",
    l_Completed: "Completed",
    l_Not_completed: "Not completed",
    l_Image_must_smaller_than_3MB: "Image must smaller than 3MB!",
    l_Image_must_smaller_than_2MB: "Image must smaller than 2MB!",
    l_Image_size_exceeds_5MB: "Image size exceeds maximum 5MB",
    l_Image_must_be_500x500: "Image must be 500x500",
    l_Image_format_error: "image format error!",
    l_Analytics: "Analytics",
    l_Status: "Status",
    l_Order_id: "Order id",
    l_Traking_number: "Traking number",
    l_Amount: "Amount",
    l_Payment_metehod: "Payment metehod",
    l_Payment: "Payment",
    l_Recipients: "Recipients",
    l_First_name: "First name",
    l_Last_name: "Last name",
    l_Type: "Type",
    l_Client: "Client",
    l_Admin: "Admin",
    l_Last_login: "Last login",
    l_Register: "Register",
    l_Verified: "Verified",
    l_Not_verified: "Verification failed",
    l_All: "All",
    l_Search: "Search",
    l_Statuses: "Statuses",
    l_Start_country: "Start country",
    l_End_country: "End country",
    l_Sort: "Sort",
    l_Add_time: "Add time",
    l_Update_time: "Update time",
    l_Ascending: "Ascending",
    l_Descending: "Descending",
    l_Create_time: "Create time",
    l_Message: "Message",
    l_Send_message: "Send message",
    l_Internal_tracking_number: "Internal tracking number",
    l_Shopping_instead: "Shopping instead",
    l_Size: "Size",
    l_Description: "Description",
    l_Link: "Link",
    l_City: "City",
    l_All_cargo: "All cargo",
    l_Volume: "Volume",
    l_Height: "Height",
    l_Paid: "Paid",
    l_Unpaid: "Unpaid",
    l_Declaration_verify: "Declaration verify",
    l_Update_date: "Update date",
    l_Add_date: "Add date",
    l_Add_to_consolidation: "Add to consolidation",
    l_Consolidation: "Consolidation",
    l_Consolidation_id: "Consolidation ID",
    l_Add_type: "Add type",
    l_Add_new: "Add new",
    l_Contractor: "Contractor",
    l_Selected_order_quantity: "Selected order quantity",
    l_Flight_number: "Flight number",
    l_Execution_date: "Execution date",
    l_Document: "Document",
    l_Add_order: "Add order",
    l_Can_choose_to_consolidation: "Can choose to consolidation",
    l_Amount_paid: "Amount paid",
    l_Payment_method: "Payment method",
    l_Card: "Card",
    l_Cash: "Cash",
    l_External_ID: "External ID",
    l_Verification_succeeded: "Verification succeeded",
    l_Verification_failed: "Verification failed",
    l_Car_number: "Car number",
    l_trailer_car_number: "Trailer car number",
    l_Foreign_warehouse: "Foreign warehouse",
    l_Almaty_warehouse: "Almaty warehouse",
    l_Info: "Info",
    l_Payment_amount: "Payment amount",
    l_Automatic_storage_filter_cleared_when_refresh: "Automatic storage filter, cleared when refresh",
    l_Not_found: "Not found",
    l_Contract_template: "Contract template",
    l_File_format_error: "File format error!",
    l_Back_home_page: "Back Home",
    l_Picked_up: "Picked up",
    l_Not_picked_up: "Not picked up",
    l_Payment_status: "Payment reason-status",
    l_Ready_to_ship: "Ready_to_ship",
    l_Belongs_category: "Belongs category",
    l_File: "File",
    l_Poster: "Poster",
    l_format_error: "Format error",
    l_TN_CODE: "TNVED code",
    l_Other: "Other",
    l_Company: "Company",
    l_Order_tracking: "Order tracking",
    l_Not_fount: "Not fount",
    l_Submit_and_print_label: "Submit and print label",
    l_Are_you_sure_update_password: "Are you sure update password?",
    l_Print_: "Print",
    l_Operator: "Operator",
    l_Russian_language: "Russian language",
    l_Print_label: "Print label",
    l_Warehouse: "Warehouse",
    l_Checking: "Under review",
    l_Verification_failed_description: "Failure reason",
    l_App_version: "App version",
    l_App_version_title: "Version title",
    l_App_version_content: "Version content",
    l_App_version_system: "App system",
    l_Version: "Version number",
    l_Force_update: "Need to force update?",
    l_Published: "Published",
    l_Unpublished: "Unpublished",
    l_Select: "Select",
    l_Gross_weight: "Gross weight",
    l_Join_warehouse: "Join warehouse",
    l_Batch_number: "Batch number",
    l_Unclaimed_order: "Unclaimed order",
    l_China_batch: "CN batch",
    l_Reject_order: "Reject order",
    l_Mini_batch: "Mini batch",
    l_Kazakhstan_batch: "KZ batch",
    l_Branch_warehouse: "Branch",
    l_Driver: "Driver",
    l_Dest_station: "Dest station",
    l_Batch: "Batch",
    l_Shelf: "Shelf",
    l_Add_to_shelf: "Add to shelf",
    l_Data: "Data",
    l_Settings: "Settings",
    l_Creator: "Creator",
    l_Shelf_number: "Shelf number",
    l_Sorting_center: "Sorting center",
    l_Pick_up: "Pick up",
    l_Scan: "Scan",
    l_Last_six_digits_of_mobile_number: "Last six digits of mobile number",
    l_Branch_batch: "Branch batch",
    l_Arrived_to_branch: "Arrived to branch",
    l_Arrived: "Arrived",
    l_Export_excel: "Export Excel",
    l_Work_time: "Work time",
    l_Manager: "Manager",
    l_Province: "Province",
    l_Remark: "Remark",
    l_Start: "Start",
    l_End: "End",
    l_Do_not_add_randomly: "Do not add randomly!",
    l_Find_branch: "Find branch",
    l_Refresh: "Refresh",
    l_Has_photo: "Has photo",
    l_Valid_time: "Valid time",
    l_Info_api: "Info API",
    l_Visible_state: "Visible state",
    l_File_update_time: "File update time",
    l_Time: "Time",
    l_Created: "Created",
    l_Group_payment: "Group payment",
    l_Permission: "Permission",
    l_System: "System",
    l_Tag: "Tag",
    l_Road_type: "Road type",
    l_Official: "Official",
    l_Commerce: "Commerce",
    l_Recommended_shelf: "Recommended shelf",
    l_Amount_payable_by_the_client: "Amount payable by the client",
    l_Payment_completed: "Payment completed",
    l_Error_batch: "Error batch",
    l_Error_order: "Error order",
    l_Error_mini_batch: "Error mini batch",
    l_Work: "Work",
    l_China_logistics: "China logistics",
    l_Receiver: "Receiver",
    l_Transport_day: "Transport day",
    l_Day: "Day",
    l_tel_merge: "Phone merge",
    l_Abnormal_order: "Abnormal order",
    l_Customs: "Customs",
    l_Contract: "Contract",
    l_Invoice: "Invoice",
    l_Filter: "Filter",
    l_CN_category_id: "CN category id",
    l_Prohibited_catgegories: "Prohibited categories",
    l_Error: "A technical error has occurred! Please send a screenshot to IT.",
    l_Those_whose_weight_is_over_31_kg: "Those whose weight is over 31 kg",
    l_The_price_is_more_than_1000: "The price is more than 1000$",
    l_Price_over_1000_and_weight_over_31_kg: "Price over 1000$ and weight over 31kg",
    l_Net_weight: "Net weight",
    l_Overall_weight: "Overall weight",
    l_History: "History",
    l_Updated_time: "Updated time",
    l_Order_count: "Order count",
    l_Unknown: "Unknown",
    l_Mini_batch_count: "Mini batch count",
    l_Return_order: "Return order",
    l_Change_branch: "Change branch",
    l_Image: "Image",
    l_Search_in_shelf: "Search in shelf",
    l_Translation: "Translation",
    l_Primary_language: "Primary language",
    l_Content: "Content",
    l_Translated_language: "Translated language",
    l_Check_the_category_of_KTZ: "Check the category of KTZ",
    l_There_is_KTZ_category: "There is a KTZ category",
    l_There_is_no_category_KTZ: "There is no category KTZ",
    l_Are_you_sure_of_the_correctness_of_the_data: "Are you sure of the correctness of the data?",
    l_Statistic: "Statistic",
    l_China_warehouse: "China warehouse",
    l_Sorting: "Sorting",
    l_Role: "Role",
    l_Stay_branch_day: "Stay branch day",
    l_Min_weight: "Min weight",
    l_Menu: "Menu",
    l_Left_from_Almaty: "Left from Almaty",
    l_Left_from_China: "Left from China",
    l_Almaty_warehouse_received: "Almaty warehouse received",
    l_China_warehouse_received: "China warehouse received",
    l_Jpid_build_by_minibatch: "Jpid built by minibatch",
    l_Weighed_id: "Weighed id",
    l_Close: "Close",
    l_Article: "Article",
    l_Employees: "Employees",
    l_Visibility: "Visibility",
    l_Can_view: "Can view",
    l_Admin_worker: "Admin worker",
    l_Web: "Web",
    l_General: "General",
    l_Door_to_door: "Door to door",
    l_Pending_orders: "Pending orders",
    l_In_delivery: "In delivery",
    l_Received: "Received",
    l_Reject: "Reject",
    l_Pending: "Pending",
    l_Supervision: "Supervision",
    l_Language: "Language",
    l_Agent: "Agent",
    l_My_Statistics: "My Statistics",
    l_Count_Stats: "Count  Statistics",
    l_Number_of_products_that_do_not_match_the_branch: "Number of products that do not match the branch",
    l_Quantity_of_goods: "Quantity of goods",
    l_Delivery_to_me: "Delivery to me",
    l_Batch_statistics: "Batch statistics",
    l_Returned_to_China_Courier: "Returned to China Courier",
    l_Feedback: "Feedback",
    l_Accepted: "Accepted",
    l_In_progress: "In progress",
    l_Weight_change_history: "Weight change history",
    l_Public_document: "Public document",
    l_Recovery: "Recovery",
    l_Logistic: "Logistic",
    l_Regional_center: "Regional center",
    l_Internal_logistics: "Internal logistics",
    l_Branch: "Branch",
    l_Dont_match: "Dont match",
    l_Additional_document: "Additional document",
    l_Additional_price: "Additional price",
    l_Weight_difference: "Weight difference",
    l_Dead_goods: "Dead goods",
    l_List: "List",
    l_Result: "Result",
    l_Reason: "Reason",
    l_Negotiate_order_prices: "Negotiate order prices",
    l_Negotiate_road_prices: "Negotiate road prices",
    l_Bank_account: "Bank account",
    l_Finish: "Finish",
    l_Revise: "Revise",
    l_Alert_on_revision: "Revision time has not started",
    l_Save: "Save",
    l_Create: "Create",
    l_Schedule: "Schedule",
    l_Coming: "Coming",
    l_Reception: "Reception",
    l_Put_on_the_shelf: "Put on the shelf",
    l_Distribution: "Distribution",
    l_Average_weight: "Average weight",
    l_Dependent_region: "Dependent region",
    l_Reset_permission: "Reset permission",
    l_Cannot_be_deleted: "Cannot be deleted",
    l_Region: "Region",
    l_Operator_statistic: "Operator statistic",
    l_People_who_uploaded_the_document: "People who uploaded the document",
    l_Reset: "Reset",
    l_Rejected_order: "Rejected order",
    l_Warning_Has_an_impact_on_statistics: "Warning! Has an effect on statistics.",
    l_Fragile_products: "Fragile products",
    l_Work_schedule: "Work schedule",
    l_Sorting_machine: "Sorting machine",
    l_Unique: "Unique",
    l_Repeated: "Repeated",
    l_Machine: "Machine",
    l_App_service: "App service",
    l_Badge: "Badge",
    l_Services: "Services",
    l_Order_status: "Order status",
    l_In_several_branches: "In several branches",
    l_Not_in_database: "Not in database",
    l_Correct: "Correct",
    l_Revision: "Revision",
    l_Ticket: "Ticket",
    l_Detail: "Detail",
    l_Answer: "Answer",
    l_Receive_client: "Receive from client",
    l_Work_order: "Work order",
    l_Order_code: "Order-code",
    l_Send_address: "Send address",
    l_Receive_name: "Receive name",
    l_Receive_contact: "Receive contact",
    l_Receive_address: "Receive address",
    l_Express_Company_Id: "Express company id",
    l_Express_Dealer: "Express Dealer",
    l_Express_Dealer_Contact: "Express Daaler contact",
    l_Compensate_Amount: "Compensate amount",
    l_Reply_type: "Reply type",
    l_Handle_result: "Handle result",
    l_Call_result: "Call result",
    l_Pay_amount: "Goods price",
    l_Compensate_state: "Compensate state",
    l_sign_state: "Sign state",
    l_Replied: "Replied",
    l_Not_replied: "Not replied",
    l_Orders_in_shelf: "Orders in shelf",
    l_Tariff: "Tariff",
    l_Filter_settings: "Setting up filters",
    l_PDD_received: "PDD received",
    l_Wallet: "Wallet",
    l_Bonus: "Bonus",
    l_Refund_account: "Responsible for return",
    l_Duty: "Duty",
    l_The_call_was_connected_but_there_was_no_response: "The call was connected, but there was no response",
    l_Wrong_number: "Wrong nomber ",
    l_Phone_is_busy: "Phone is busy",
    l_No_response: "No response",
    l_Other_person: "Other person",
    l_By_default: "By default",
    l_Not_signed: "Not signed",
    l_Signed: "Signed",
    l_Cargo_company: "Cargo company",
    l_Seller: "Seller",
    l_Will_not_compensate: "Not compensated",
    l_Will_compensate: "Compensated",
    l_Answered: "Answered",
    l_Replied_at: "Replied time",
    l_Consumer: "Consumer",
    l_Multi: "Multi",
    l_Normal: "Normal",
    l_Added_to_task: "Added to task",
    l_Big_box: "Big box",
    l_Task: "Task",
    l_Has: "Has",
    l_None: "None",
    l_All_answers: "All answers",
    l_Already_scanned: "Already scanned!",
    l_Terminal: "Terminal",
    l_The_branch_does_not_match: "The branch does not match",
    l_End_time: "End time",
    l_Left: "Left",
    l_Reached_the_center: "Reached the center",
    l_Left_from_the_center: "Left from the center",
    l_Scan_time: "Scan time",
    l_App_news: "App news",
    l_Title: "Title",
    l_Check_list: "Checklist",
    l_Total_average: "Total average score",
    l_Operation_JPID: "Operation JPID",
    l_Average_score: "Average score",
    l_Criteria_name: "Criteria name",
    l_Score: "Score",
    l_Check_list_add: "Add checklist",
    l_Criteria_add: "Add criteria",
    l_Checked_date: "Cheched date",
    l_User_restore: "User restore",
    l_App_articles: "App articles",
    l_Partner: "Partner",
    l_News: "News",
    l_Lost: "Lost",
    l_Video: "Video",
    l_Statement: "Statement",
    l_Serve_speed: "Serve speed",
    l_Send_by_file: "Send by file",
    l_Send_one: "Send one",
    l_Late_goods: "Late goods",
    l_Warehouse_payment: "Warehouse payment",
    l_Registration: "Registration",
    l_Destroy: "Destroy",
    l_Sold: "Sold",
    l_Burned: "Burned",
    l_Rework: "Rework",
    l_Scan_with_app: "Scan using the Jana Post app",
    l_Send: "Send",
    l_Destroyed: "Destroyed",
    l_Questions: "Questions",
    l_Question: "Question",
    l_Rating: "Rating",
    l_Star: "Star",
    l_Sender: "Sender",
    l_Rate_type: "Rate type",
    l_Rate_question: "Rate question",
    l_Worker: "Worker",
    l_Delivery: "Delivery time",
    l_File_must_be_less_than_5_MB: "File must be less than 5 MB!",
    l_Finish_sorting: "Finish sorting",
    l_Barcode: "Barcode",
    l_Inner_logistic_finish: "Inner logistic finish",
    l_Table: "Table",
    l_Charts: "Charts",
    l_Option: "Option",
    l_Options: "Options",
    l_Results: "Results",
    l_Partners: "Partners",
    l_Resume: "Resume",
    l_Finance: "Finance",
    l_Scanzona: "Scanzona",
    l_Scanned_in_zona: "Scanned in zona",
    l_Complaints: "Complaints",
    l_Responsible_department: "Responsible department",
    l_User_feedback: "User feedback",
    l_Recipient_stats: "Recipient stats",
    l_Transportation_time: "Transportation time",
    l_Hour: "Hour",
    l_Employee_discount: "Employee discount",
    l_Add_filials: "Add filials",
    l_Filial_list: "Filial list for partners",
    l_Partnership: "Partnership",
    l_Count: "Count for per city",
    l_Branches_for_partners: "Filials for partners",
    l_Plomb: "Plomb",
    l_Latitude: "Latitude",
    l_Longitude: "Longitude",
    l_By_file: "By file",
    l_By_filter: "By filter",
    l_User_count: "User count",
    l_Name_fill: "Your full name",
    l_Address_fill: "",
    l_individualEntrepreneur: "Are you individual entepreneur?",
    l_Address_link: "Please insert your 2GIS address link",
    l_Have_you_ordered: "Have you ordered before? If yes, left your order JPID",
    l_Open_your_own_branch: "Open your own branch",
    l_Based_on_your_current_location_are_you_in_Kazahstan: "Based on your current location, you are in Kazakhstan",
    l_Based_on_your_current_location_are_you_in_Uzbekistan: "Based on your current location, you are in Uzbekistan",
    l_Based_on_your_current_location_are_you_in_Kyrgyzstan: "Based on your current location, you are in Kyrgyzstan",
    l_Based_on_your_current_location_are_you_in_Tajikistan: "Based on your current location, you are in Tajikistan",
    l_Based_on_your_current_location_are_you_in_Mongolia: "Based on your current location, you are in Mongolia",
    l_Continue: "Continue",
    l_Access_to_geodata_is_not_allowed: "Access to geodata is not allowed. Unable to determine location",
    l_Location_information_is_unavailable: "Location information is unavailable.",
    l_your_bday: "Your birthday",
    l_knowledge: "Your level of education",
    l_is_there_experience: "Have you ever had ewperience in business?",
    l_is_there_2million: "Do ypu have at least 2 millions to open a branch?",
    l_Lower: "By spesiality",
    l_Middle: "Middle level",
    l_Upper: "Upper level",
    l_Add_partners: "Add partners",
    l_Communication: "Communication",
    l_Area_covered: "Area covered",
    l_Document_service: "Document service",
    l_The_shelf_number_should_start_with_JP: "The shelf number should start with JP",
    l_All_near_branches: "All near branches",
    l_Important: "Important",
    l_New_station: "New station",
    l_Branch_near_by: "Branch near by",
    l_Branch_open_warehouse: "All opened branches",
    l_Need_branch: "Need to choose branch",
    l_Daily_Count_Stats: "Daily count statistic",
    l_Agreement_branch: "Agreement Branch",
    l_Agreement_sign: "Agreement Sign",
    l_Batch_not_installed: "Batch not installed",
    l_Excel_print: "Print Excel (orders)",
    l_Reading_list: "Reading list",
    l_Marketing: "Marketing",
    l_Number: "Number",
    l_Home_delivery: "Home delivery",
    l_Matching: "Matching",
    l_Track_analytic: "Track analytic",
    l_Call_center: "Call center",
    l_On_the_shelf: "On the shelf",
    l_Delivered: "Delivered",
    l_Available_offers: "Available offers",
    l_Courier: "Courier",
    l_Enabled: "Enabled",
    l_Disabled: "Disabled",
    l_Identification_to_branch: "identification to branch",
    l_Personal: "Personal",
    l_Finished_the_job: "Finished the job",
    l_Completeness: "Completeness",
    l_Timeliness: "Timeliness",
    l_Timeliness_24h: "Timeliness 24h",
    l_On_time_delivery: "On time delivery",
    l_On_time: "On time",
    l_Late: "Late",
    l_Total: "Total",
    l_Percent: "Percent",
    l_Margin: "Margin",
    l_Loss: "Loss",
    l_Income: "Income",
    l_Today: "Today",
    l_Yesterday: "Yesterday",
    l_Day_before_yesterday: "Day before yesterday",
    l_Last_status: "Last status",
    l_Static_tracks: "Static tracks",
    l_Mini_batch_destination: "Destination of the M-Batch",
    l_Not_matched_stations: "Not matched orders with Stationcode",
    l_Count_order_mbatch: "Count of orders in M-Batch",
    l_No_branches_choosed: "No branch choosed",
    l_Agree_to_change_branches: "With agreeing with this, you will change branches of this orders to this M-Btach's choosen branch",
    l_Change: "Change",
    l_Preparation_for_distribution: "Preparation for distribution",
    l_Distribution_to_the_basket: "Distribution to the basket",
    l_Coordinate_status: "Coordinate status",
    l_Delivery_status: "Delivery status",
    l_Number_of_baskets: "Number of baskets",
    l_Basket_add: "Basket add",
    l_Basket_number: "Basket number",
    l_Courier_reseived: "Courier received",
    l_Courier_didnt_reseived: "Courier didn't received",
    l_Courier_jpcr: "Courier JPCR",
    l_Need_to_scan_the_courier_JPCR: "Need to scan the courier JPCR",
    l_Need_to_scan_the_basket_number: "Need to scan the basket number",
    l_First_scan_the_basket_number_to_check_the_status: "First scan the basket number to check the status",
    l_Last_time: "Last time",
    l_Clear: "Clear",
    l_Basket_list: "Basket list",
    l_Withdrawal_of_an_order: "Withdrawal of an order",
    l_Basket: "Basket",
    l_Adding_an_order_to_the_shelf: "Adding an order to the shelf",
    l_Distribution_of_the_order_in_the_basket: "Distribution of the order in the basket",
    l_Couriers: "Couriers",
    l_To_divide_the_basket_you_need_to_add_the_order_to_the_shelf: 'To allocate the order to the basket, the order must be added to the shelf or the delivery status must be "Preparing allocation" !',
    l_Only_those_whose_coordinates_are_found_are_allocated_in_the_basket: "Only those whose coordinates are found are allocated in the basket",
    l_Orders_in_the_basket: "Orders in the basket",
    l_Courier_refused: "Courier refused",
    l_Recommended_basket: "Recommended basket",
    l_Number_of_goods_in_preparation_for_distribution: "Number of goods in preparation for distribution",
    l_Frozen_state: "Frozen state",
    l_Be_careful_when_freezing_the_order: "Be careful when freezing the order !",
    l_Branch_orders: "Branch orders",
    l_Problem_description: "Problem description",
    l_Go_to_website: "Go to website",
    l_Invite_list: "Invite list",
    l_Inviter_JPID: "Inviter JPID",
    l_Add_order_to_the_Basket: "Add the order to the basket",
    l_Preparing_the_basket_in_the_order: "Preparing the order in the basket",
    l_Write_the_number_of_the_basket_where_the_orders_will_be_placed: "Write the number of the basket where the orders will be placed!",
    l_Order_withdrawal_from_courier: "Order withdrawal from courier",
    l_Distribution_of_the_order_to_the_courier_shelf: "Distribution of the order to The Courier shelf",
    l_Courier_shelf_list: "Courier shelf list",
    l_Orders_on_the_courier_shelf: "Orders on the courier shelf",
    l_Placing_the_order_on_the_courier_shelf: "Placing the order on the courier shelf",
    l_Courier_shelf_number: "Courier shelf number",
    l_Preparing_the_order_for_the_courier_shelf: "Preparing the order for the courier shelf",
    l_Adding_an_order_to_the_courier_shelf: "Adding an order to the courier shelf",
    l_Place_on_the_courier_shelf: "Place on the courier shelf",
    l_Allocation_to_the_courier_rack: "Allocation to the courier rack",
    l_Division_into_shelves: "Division into shelves",
    l_Shipping_price: "Shipping price",
    l_Cost_price: "Cost price",
    l_NORTH: "NORTH",
    l_SOUTH: "SOUTH",
    l_WEST: "WEST",
    l_EAST: "EAST",
    l_Over45days: "Over 45 days",
    l_Text: "Text",
    l_Order_rectify: "Rectify order",
    l_Not_received: "Not received",
    l_Department: "Department",
    l_Operation_time: "Operation time",
    l_Tracks: "Tracks",
    l_Adding_a_courier_order: "Adding a courier order",
    l_Sending_to_courier: "Sending to courier",
    l_Regulation: "Regulation",
    l_Orders_that_should_be_frozen: "Orders that should be frozen",
    l_On_the_courier: "On the courier",
    l_Goods_older_than_15_days: "Goods older than 15 days",
    l_Frozen: "Frozen",
    l_Late_delivered_orders: "Late delivered orders",
    l_Number_of_days: "Number of days",
    l_Undelivered_goods: "Undelivered orders",
    l_More_details: "More details",
    l_Client_received: "Client received",
    l_Stuck_orders: "Stuck orders",
    l_Check: "Check",
    l_District: "District",
    l_Store: "Store",
    l_Route: "Route",
    l_Branch_batch_count: "Branch batch count",
    l_Last_freeze_day: "Last freeze day",
    l_Level: "Level",
    l_Undelivered: "Undelivered",
    l_New_user: "New user",
    l_Sending_a_verification_code_to_the_client: "Sending a verification code to the client",
    l_Confirmation_code: "Confirmation code",
    l_Transit_count: "Transit count",
    l_Wrong_tracks: "Wrong tracks",
    l_Normal_tracks: "Normal tracks",
    l_Goods_lost_or_broken: "Goods lost or broken",
    l_Load_data: "Load data",
    l_China_storage: "China storage",
    l_Inner_logistics: "Inner logistics",
    l_Warning: "Warning",
    l_Penalty: "Penalty",
    l_Day_left_to_return: "Day left to return",
    l_Reason_for_rejection: "Reason for rejection",
    l_Rejection: "Rejection",
    l_DepartmentId: "DepartmentId",
    l_Patronymic: "Patronymic",
    l_Inviter: "Inviter",
    l_Awaiting_a_refund: "Awaiting a refund",
    l_Send_push_message: "Send push message",
    l_Order_search: "Order search",
    l_Exported: "Exported",
    l_Arrival_transfer_center: "Arrival transfer center",
    l_Export_clearance_start: "Export clearance start",
    l_Export_clearance_finish: "Export clearance finish",
    l_Departure_foreign: "Departure foreign",
    l_Reached_Kazakhstan: "Reached Kazakhstan",
    l_Import_clearance_start: "Import clearance start",
    l_Import_clearance_finish: "Import clearance finish",
    l_Package_status: "Package status",
    l_Arrival_branch: "Arrived to branch",
    l_Chinese_address: "Chinese address",
    l_Fill_in_the_information: "Fill in the information",
    l_Day_delivered: "day delivered",
    l_Day_delivering: "day delivering",
    l_Client_address: "Client's address",
    l_Warehouse_address: "Warehouse address",
    l_Domestic_Express__Affordable_Prices: "Domestic Express",
    l_Resubmit: "Resubmit",
    l_Add_language: "Add language",
    l_Create_discount: "Create discount",
    l_Please_enter_jpid: "Please enter JPID",
    l_Video_guide: "Video guide",
    l_Max_upload_weight: "Maximum file size — {size}",
    l_Story_feed: "Story feed",
    l_Story: "Story",
    l_Media: "Media",
    l_Button: "Button",
    l_Marketplace: "Marketplace",
    l_China_warehouse_address: "China warehouse address",
    l_After_copy_url: "After copy URL",
    l_Confirm_action: "Confirm the action.",
    l_VIP_client: "VIP client",
    l_Notification: "Notification",
    l_Back_to_school: "Back to school",
    l_Categories: "Categories",
    l_Add_category: "Add category",
    l_Add_subcategory: "Add subcategory",
    l_Subcategory: "Subcategory",
    l_Hidden: "Hidden",
    l_Products: "Products",
    l_Add_bts_product: "Add product",
    l_Product_link: "Product link",
    l_Horizontal_placement: "Horizontal placement",
    l_Limit: "Limit",
    l_Characters: "characters",
    l_Enter_https_url: "Enter a valid https URL",
    l_Push_category: "Push category",
    l_By_category: "By category",
    l_Min_count_required: "At least {count} {element} required",
    l_Max_count_allowed: "Maximum {count} {element} allowed",
    l_Only_latin_letters_allowed: "Latin letters, digits, “-”, “_” only",
    l_Error_500: "Internal server error. Please try again later.",
    l_Janapost_link: "JanaPost link",
    l_Internal_link: "Internal link",
    l_Shared_link: "Shared link",
    l_Upload_video: "Upload video",
    l_Enter_link: "Enter link",
    l_External_link: "External link",
    l_Buttons: "Buttons",
    l_Add_Image_and_buttons: "Add Image and buttons",
    l_Free_delivery: "Free delivery",
    l_Statistics: "Statistics",
    l_Mastercard_payments: "Mastercard payments",
    l_Total_payment_amount: "Payment amount",
    l_Promotion_amount: "Amount with promotion",
    l_Total_payment_count: "Payment count",
    l_Total_unique_users: "Unique users",
    l_Please_fill_in_this_field: "Please fill in this field",
    l_Deleted_accounts: "Deleted accounts",
    l_Context: "Context",
    l_Reasons_for_account_deletion: "Reasons for account deletion",
    l_Client_type: "Client type",
    l_Client_filter: "Client filter",
    l_By_has_order: "By orders existing",
    l_By_the_order_time: "By order time",
    l_Push_send_confirm: "The message will be sent to {count} users! Is this number correct?",
    l_Has_order_yes: "Has orders",
    l_Has_order_no: "No orders",
    l_Select_has_order: "Select orders existing",
    l_Select_order_time: "Select order time",
    l_Stories: "Stories",
    l_Stories_banner_statistics: "Stories statistics",
    l_Max_day_count: "Allowed time range: {count} days",
    l_Error_occured: "An error occurred. Try again later.",
    l_Promo_code: "Promocode",
    l_Common: "Common",
    l_Default: "Default",
    l_New: "New",
    l_Soon: "Soon",
    l_System_send: "System send",
    l_Enter_promo_code: "Enter promocode / JPID / phone number",
    l_Owner: "Owner",
    l_Bonus_discount: "Bonus / Discount",
    l_Enter_bonus_amount: "Enter bonus amount",
    l_Usage_count: "Usage count",
    l_Expiration_date: "Expiration date",
    l_Enter_expiration_date: "Enter expiration date",
    l_Active: "Active",
    l_Inactive: "Inactive",
    l_Expired: "Expired",
    l_View: "View",
    l_Disable: "Disable",
    l_Platform: "Platform",
    l_Device: "Device",
    l_Conversion: "Conversion",
    l_Earned_bonus: "Earned bonuses",
    l_Burned_bonus: "Burned bonuses",
    l_System_promo_code: "System promocode",
    l_Distribution_channels: "Distribution channels",
    l_Enter_description: "Enter description / additional information",
    l_Select_at_least_one_distribution_channels: "Select at least one distribution channel",
    l_Old_first: "Old first",
    l_New_first: "New first",
    l_User_promo_code: "User promocode",
    l_Enter_title_in_ru: "Enter title in Russian",
    l_Enter_title_in_kk: "Enter title in Kazakh",
    l_Enter_description_in_ru: "Enter description in Russian",
    l_Enter_description_in_kk: "Enter description in Kazakh",
    l_Send_count: "Send count",
    l_Expired_count: "Expired count",
    l_Used_amount: "Used amount",
    l_Expired_amount: "Expired amount",
    l_Date_type: "Date type",
    l_Period: "Period",
    l_Are_you_sure_to_off_promocode: "Are you sure to off promocode?",
    l_Are_you_sure_to_on_promocode: "Are you sure to on promocode?",
    l_Please_fill_all_fields: "Please fill all fields",
    l_Please_select_a_promo_code: "Please select a promo code",
    l_Are_you_sure_in_filled_fields: "Are you sure in correctness of this fields?",
    l_Last_usage_time: "Last usage time",
    l_Loading: "Loading, please wait...",
    l_Kazakhstan: "Kazakhstan",
    l_Kyrgyzstan: "Kyrgyzstan",
    l_Uzbekistan: "Uzbekistan",
    l_Tajikistan: "Tajikistan",
    l_Mongolia: "Mongolia",
    l_Promo_disabled: "Promo code disabled successfully",
    l_Promo_enabled: "Promo code enabled successfully",
    l_Field_cannot_be_empty: "Field cannot be empty",
    l_Push_sent_successfully: "Push notification sent successfully",
    l_Successfully_updated: "Successfully updated",
    l_Kazakh: "Kazakh",
    l_Russian: "Russian",
    l_English: "English",
    l_Currency: "Currency",
    l_Select_currency: "Select currency",
    l_Successfully_created: "Successfully created",
    l_Something_went_wrong: "Something went wrong. Please try again later.",
    l_Must_be_more_than_zero: "Amount must be more than zero",
    l_User_send_count: "User send count",
    l_Active_time: "Active time",
    l_For_one_promocode: "For one promocode",
    l_Promocode_expired: "Promocode expired",
    l_By_days: "By days",
    l_By_exact_date: "By exact date",
    l_Enter_days: "Enter days (will change from today)",
    l_Please_wait_seconds: "Please wait a few seconds.",
    l_This_sign_is_not_allowed: "This sign is not allowed",
    l_Promo_code_title: "Promocode title",
    l_Redemption_policy: "Redemption policy",
    l_Standard: "Standard",
    l_Single_use_burn_remainder: "Single use (Burn remainder)",
    l_Select_redemption_policy: "Select redemption policy",
    l_Enter_promo_code_only: "Enter promocode title",
    l_Remote_config: "Remote config",
    l_Remote_config_info: "Info",
    l_Remote_config_social: "Social networks",
    l_Remote_config_legal: "Legal documents",
    l_Remote_config_features: "Features",
    l_Remote_config_devmode: "Dev mode",
    l_Remote_config_home_page_promo_icon: "BTS config",
    l_Remote_config_image_url: "Image URL",
    l_Remote_config_general: "General",
    l_Remote_config_bin: "BIN",
    l_Remote_config_about_app: "About app",
    l_Remote_config_search_url: "Search URL",
    l_Remote_config_contact: "Contact",
    l_Remote_config_feedback_email: "Feedback email",
    l_Remote_config_feedback_url: "Feedback URL",
    l_Remote_config_support_service: "Support service",
    l_Remote_config_app_url: "App URL (deeplink)",
    l_Remote_config_web_url: "Web URL",
    l_Remote_config_public_contract: "Public contract",
    l_Remote_config_agreement: "Agreement",
    l_Remote_config_tracking_numbers: "Test tracking numbers",
    l_Remote_config_social_facebook: "Facebook",
    l_Remote_config_social_instagram: "Instagram",
    l_Remote_config_social_tiktok: "TikTok",
    l_Remote_config_social_youtube: "YouTube",
    l_Remote_config_social_telegram: "Telegram",
    l_Remote_config_social_whatsapp: "WhatsApp",
    l_Remote_config_feature_education: "Education",
    l_Remote_config_feature_domestic: "Domestic delivery",
    l_Remote_config_feature_addOrder: "Add order",
    l_Remote_config_feature_inviteFriend: "Invite friend",
    l_Remote_config_feature_copyAddress: "Copy address",
    l_Delete: "Delete",
    l_Value: "Value",
    l_Home_banner: "Home Banner",
    l_Add_home_banner: "Add Home Banner",
    l_Update_home_banner: "Update Home Banner",
    l_Show_period: "Show period",
    l_Show_period_hint: "Enter show period",
    l_No_period_limit: "No period limit",
    l_Views: "Views",
    l_Clicks: "Clicks",
    l_Statistics_update_hint: "Statistics is updated once a day",
    l_Manage_order: "Manage order",
    l_Url: "Outside link",
    l_App_section: "App section",
    l_Show_from: "Show from",
    l_Show_to: "Show to",
    l_Enter_sort_number: "Enter sort number",
    l_Preview: "Preview",
    l_Select_language_to_reorder: "Select language to reorder",
    l_No_data: "No data",
    l_End_time_cannot_be_in_past: "End time cannot be in the past",
    l_Active_now: "Active now",
    l_Scheduled: "Scheduled",
    l_Copied: "Copied",
    l_New_version_logo: "New version logo",
    l_New_version_video: "New version video",
    l_Until: "Until {time}",
    l_From: "From {time}",
    l_How_to_fill_link_field: "How to fill the link field",
    l_Opens_screen_inside_app: "opens a screen inside the app.",
    l_Allowed_values: "Allowed values",
    l_Unknown_module_banner_not_open: "Any other value — the banner will not open anything.",
    l_Opens_external_link_examples: "opens an external link. Examples",
    l_Website: "Website",
    l_App_not_installed_web_fallback: "If the app (WhatsApp, Telegram, etc.) is not installed, the web version will open automatically.",
    l_Branches: "Branches",
    l_Pickup: "Pickup",
    l_Enter_valid_link: "Enter a valid link (https://... or a deep link)",
    l_Module_value_type: "Open as",
    l_From_list: "App section from list",
    l_Banner_link_help_title: "What happens when the banner is tapped",
    l_Help_url_desc: "opens an external link in the browser or in the app. Examples:",
    l_Help_module_desc: "opens content inside our app. Two options:",
    l_Help_module_list_desc: "opens a ready-made screen (Jana Drive, Branches, FAQ, etc.)",
    l_Help_module_url_desc: "opens the link inside the app (WebView), without leaving to the browser",
    l_Url_short: "URL",
    l_Help_module_only_five_note: "Only 5 sections are available in the list so far: Jana Drive, Branches, FAQ, Pickup, Settings. Other sections must be linked via a URL. Before linking a banner to another section, we recommend clarifying the exact path first.",
    l_Information_block_banner: "Recommended information before use",
    l_Required_field: "Required field",
    l_Change_history: "Change history",
    l_Updated_by: "Updated by",
    l_History_create: "Created",
    l_History_update: "Updated",
    l_History_enable: "Enabled",
    l_History_disable: "Disabled",
    l_History_delete: "Deleted",
    l_Home_page: "Home",
    l_Promocode_actions: "Promocode",
    l_Export_to_excel: "Export to Excel",
    l_Create_promo_action: "Create action",
    l_Search_by_promocode: "Search by promocode",
    l_Enter_promocode: "Enter promocode",
    l_Promo_action_name: "Action name",
    l_Bonus_amount: "Bonus amount",
    l_Period_range: "Period",
    l_Used_count: "Used",
    l_Promo_finished: "Finished",
    l_Promo_stopped: "Stopped",
    l_Total_records: "Total {count} records",
    l_Per_page: "page",
    l_Country_label: "Country",
    l_Url_example: "If you need to show an application page, enter jana_webview:https://...",
    l_Please_enter_full_name: "Enter full name",
    l_Please_enter_email: "Enter email",
    l_Please_enter_valid_email: "Enter a valid email",
    l_Archive: "Archive",
    l_Archived_promo_actions: "Archived promocode promotions",
    l_Back_to_promo_actions: "Back to promocode promotions",
    l_Archived_date: "Archived date",
    l_Make_copy: "Make a copy",
    l_Restore: "Restore",
    l_Export_to_excel_v2: "Export to Excel",
    l_Choose: "Choose",
    l_Choose_country: "Choose country",
    l_General_section: "General",
    l_Enter_promo_name: "Enter promo action name",
    l_Enter_bonus: "Enter bonus amount",
    l_Promocode_conditions: "Conditions for bonus",
    l_Immediately_after_code: "Immediately after code entry",
    l_After_order: "After order",
    l_Order_type: "Order type",
    l_Order_status_paid: "Paid",
    l_Order_status_delivered: "Delivered",
    l_Which_order_counts: "Order counts",
    l_First_order: "First order",
    l_Any_order: "Any order",
    l_Select_placeholder: "Select a value",
    l_Period_and_limits: "Validity period and limits",
    l_Start_date: "Start date",
    l_End_date: "End date",
    l_Select_date: "Select date",
    l_Unlimited: "Unlimited",
    l_Bonus_lifetime_days: "Bonus lifetime, days",
    l_Enter_days_placeholder: "Enter number of days",
    l_Participant_limit: "Participant limit",
    l_Enter_limit: "Enter participant limit",
    l_Max_bonus_share: "Maximum bonus payment share",
    l_Enter_percent: "Enter a value",
    l_Percent_of_order_amount: "of order amount",
    l_Notification_texts: "Notification texts",
    l_Enter_notification_text: "Enter notification text",
    l_Draft_not_active: "Draft • not active",
    l_Save_changes: "Save changes",
    l_Launch_action: "Launch action",
    l_Changes_saved: "Changes saved",
    l_Promo_action_launched: "Promo action launched",
    l_Duplicate_action: "Duplicate action",
    l_Edit_info: "Edit information",
    l_Pause_action: "Pause action",
    l_Stop_early: "Stop early",
    l_Send_to_archive: "Send to archive",
    l_Action_period: "Action period",
    l_Bonus_condition: "Bonus condition",
    l_Calculated_bonus: "Calculated bonus",
    l_Bonus_usage_rate: "Bonus usage rate",
    l_Active_period_left: "Active period",
    l_Avg_daily_spend: "Average daily spend",
    l_Day_short: "day",
    l_Awaiting_condition: "Awaiting condition",
    l_Conversion_funnel: "Conversion funnel",
    l_Funnel_code_entered: "Entered code",
    l_Funnel_condition_fulfilled: "Condition fulfilled",
    l_Funnel_bonus_used: "Used bonus",
    l_Funnel_bonus_burned: "Bonus expired unused",
    l_Bonus_status: "Bonus status",
    l_Bonus_status_unused: "Unused",
    l_Bonus_status_spent: "Spent",
    l_Bonus_status_burned: "Burned",
    l_Bonus_status_returned: "Returned",
    l_Usage_list: "Usage list",
    l_Usage_pending: "Pending",
    l_Usage_completed: "Completed",
    l_Usage_returned: "Returned",
    l_Search_by_phone: "Search by phone number",
    l_Filters: "Filters",
    l_Client_phone: "Client (phone)",
    l_Used_at: "Used at",
    l_Calculated: "Calculated",
    l_Expire_date: "Expiry date",
    l_Order_number: "Order #",
    l_Active_tab: "Active",
    l_Archive_tab: "Archive",
    l_Search_promocode_or_name: "Enter promo code / action name",
    l_Was_sent_to_archive: "Promocode action was sent to archive",
    l_New_promo_code: "New promocode",
    l_Edit_promo_code: "Edit promocode",
    l_Duplicate_promo_code: "Duplicate promocode",
    l_Restart_promo_code: "Restart promocode",
    l_Usage_conditions: "Usage conditions",
    l_Balance_carries_over: "Balance carries over",
    l_Balance_burns_out: "Balance burns out",
    l_Order_conditions: "Order conditions",
    l_No_limit: "No limit",
    l_No_end_date: "No end date",
    l_Order_status_paid_desc: "after payment",
    l_Order_status_delivered_desc: "after delivery",
    l_First_order_desc: "first order",
    l_Any_order_desc: "any order",
    l_Applied_count: "Applied",
    l_Ordered_count: "Ordered",
    l_Accrued: "Accrued",
    l_Kg_short: "kg",
    l_Condition_fulfilled: "condition fulfilled",
    l_By_orders_with_promo: "orders with promocode",
    l_Applied_to_order: "applied -> order",
    l_Bonus_sum: "bonus sum",
    l_Spent: "Spent",
    l_Written_off_in_orders: "written off in orders",
    l_By_lifetime: "by lifetime",
    l_Returned: "Returned",
    l_Order_cancellations: "order cancellations",
    l_Actions: "Actions",
    l_Funnel_accrued: "Accrued",
    l_Funnel_bonus_spent: "Spent bonus",
    l_Funnel_burned_without_spend: "Burned without spending",
    l_Applied_at: "Applied",
    l_Applied_date: "Applied date",
    l_Date_expired: "Expired",
    l_Unlimited_v2: "Unlimited",
    l_Allow_other_promo_codes: "Allow the use of other promo codes.",
    l_Reentry_scope_per_promo: "Marketing promocode",
    l_Reentry_scope_global_lifetime: "Default promocode",
    l_Condition: "Condition",
    l_Accrual_after_warehouse: "Accrual after warehouse",
    l_Accrual_after_payment: "Accrual after payment",
    l_Accrual_immediate: "Accrual immediately",
    l_Restart_action: "Restart",
    l_Restore_from_archive: "Restore from archive",
    l_Standard_desc: "Remainder on account",
    l_Single_use_remainder_desc: "Remainder expires",
    l_Choose_status: "Choose status",
    l_Launch_now: "Launch",
    l_Duplicate: "Duplicate",
    l_Action_not_configured: "Action not configured",
    l_Stopped: "Stopped",
    l_Resume_v2: "Resume",
    l_Resumed: "Resumed",
    l_Restored_from_archive: "Restored from archive",
    l_Stop: "Stop",
    l_Promo_details: "Promocode details",
    l_Days_short: "day(s)",
    l_Remote_config_custom_order: "Custom order",
    l_Select_country: "Select country",
    l_All_countries_added: "All countries added",
    l_Feature_flags: "Feature flags",
    l_Control_groups: "Control groups",
    l_Show_to_all: "Visible to all",
    l_Show_to_group: "Visible to group",
    l_Show_by_conditions: "Visible by conditions",
    l_Countries: "Countries",
    l_Add_country: "Add country",
    l_Station_code_prefixes: "Branch prefixes",
    l_Enter_station_code_prefixes: "Enter prefixes, e.g. JP02",
    l_Station_code_prefixes_hint: "The user's home branch code must start with one of these prefixes",
    l_Conditions: "Conditions",
    l_Group_or_users_required: "Select a control group or enter at least one user",
    l_Country_or_station_prefix_required: "Select a country or enter at least one branch prefix",
    l_Code: "Code",
    l_Enter_title: "Enter title",
    l_Enter_code: "Enter code",
    l_Select_group: "Select group",
    l_Users_list: "Users list",
    l_Enter_users: "Enter users",
    l_Users_count: "Users count",
    l_Badges: "Badges",
    l_Not_set: "Not set",
    l_Text_color: "Text color",
    l_Background_color: "Background color",
    l_Approximate: "Approximate",
    l_Logo: "Logo",
    l_Enter_marketplace: "Enter marketplace",
    l_Chapters: "Chapters",
    l_No_chapters: "No chapters",
    l_Add_chapter: "Add chapter",
    l_Chapter_name: "Chapter name",
    l_Required: "Required",
    l_Start_seconds: "Start (seconds)",
    l_Duplicate_chapter_start_time: "Two chapters cannot start at the same second",
    l_Video_timeline: "Video TimeLine",
    l_Fill_all_notification_texts: "Fill all notification texts",
    l_Field_required: "Field required",
    l_Promo_action_restarted: "Promocode restarted",
    l_Fill_required_fields: "Fill required fields",
    l_Use_second_page_to_add_promocode: "Use second page to add promocode (v2)",
    l_Applied_to_spend: "application → spend",
    l_Usage_outcome_pending: "Awaiting condition",
    l_Usage_outcome_active: "On balance",
    l_Usage_outcome_spent: "Spent",
    l_Usage_outcome_expired_unused: "Expired unused",
    l_Usage_outcome_not_accrued: "Not accrued",
    l_Usage_outcome_revoked: "Revoked",
}
